import { motion } from "framer-motion";
import { Play } from "lucide-react";

const videos = [
  { id: "Sd_tCJ9zx4I", title: "G1000NXi — Professional License Demo", desc: "Watch the G1000NXi Add-On in action for Lockheed Martin Prepar3D. Full PFD/MFD simulation with synthetic vision and failure injection." },
  { id: "wBbs92_i6hE", title: "EfisFly — System Overview", desc: "Complete overview of EfisFly professional avionics simulation features, including LNAV/VNAV, AFCS and advanced failure modes." },
];

export function VideoSection() {
  return (
    <section id="videos" className="py-24 bg-secondary/40">
      <div className="container mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 280, damping: 32 }} className="mb-12">
          <p className="text-xs font-mono tracking-[0.25em] uppercase font-bold mb-2" style={{ color: "oklch(0.55 0.22 25)" }}>— In Action —</p>
          <h2 className="text-4xl md:text-5xl font-black text-foreground" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            See It <span style={{ color: "oklch(0.28 0.09 240)" }}>Fly</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {videos.map((v, i) => (
            <motion.div key={v.id} initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.12, type: "spring", stiffness: 280, damping: 32 }}
              className="bg-white rounded-xl border border-border overflow-hidden shadow-[0_4px_20px_oklch(0.12_0.03_240/0.08)] hover:shadow-[0_8px_32px_oklch(0.12_0.03_240/0.14)] transition-shadow"
              style={{ borderLeft: "4px solid oklch(0.28 0.09 240)" }}>
              <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                <iframe src={`https://www.youtube.com/embed/${v.id}?rel=0&modestbranding=1`}
                  title={v.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen className="absolute inset-0 w-full h-full" style={{ border: "none" }} />
              </div>
              <div className="p-5 flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center flex-shrink-0">
                  <Play className="w-4 h-4 text-primary fill-primary" />
                </div>
                <div>
                  <h3 className="font-bold text-foreground text-sm mb-1">{v.title}</h3>
                  <p className="text-xs text-muted-foreground leading-relaxed">{v.desc}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
